module.exports = __webpack_public_path__ + "img/indexad.52422811.png";